module.exports = __webpack_public_path__ + "static/media/pin_maestri_highlighted.caa00a1f.png";